import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { SwalComponent } from '@toverux/ngx-sweetalert2';
import { NgxSpinnerService } from 'ngx-spinner';
import { WebcamImage, WebcamInitError, WebcamUtil } from 'ngx-webcam';
import { Observable, Subject } from 'rxjs';
import { first } from 'rxjs/operators';
import { SweetAlertOptions } from 'sweetalert2';

import { Globals } from '../_helpers';
import { AlertService, AuthenticationService, PhotoauthService } from '../_services';

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-my-profile',
  templateUrl: './my-profile.component.html',
  styleUrls: ['./my-profile.component.css']
})
export class MyProfileComponent implements OnInit {
  @ViewChild('imagesizeSwal') imagesizeSwal: SwalComponent;
  public alertOption: SweetAlertOptions = {};

  @ViewChild('inputFile') attachInputVariable: ElementRef;

  // myProfileForm:FormGroup;
  fileFormControl = new FormControl('', [
    Validators.required,
  ]);

 

  matcher = new MyErrorStateMatcher();
  submitted: boolean;
  isErrorUsername: boolean;
  imageUrl: File = null;
  size: any;
  loading: boolean;
  errorMsg: any;
  studentid: number = 0;
  userinfo: any;
  studentdetails: any = [];

  imageSrc: string = '';
  imageShow: any;
  profilepic: string = '';
  isPicTaken = true;

   /* webcam Settings */
   public iscameraLoaded: boolean = false;
   public showWebcam = true;
   public allowCameraSwitch = true;
   public multipleWebcamsAvailable = false;
   public deviceId: string;

   public errors: WebcamInitError[] = [];

   // latest snapshot
   public webcamImage: WebcamImage = null;

   // webcam snapshot trigger
   private trigger: Subject<void> = new Subject<void>();

   // switch to next / previous / specific webcam; true/false: forward/backwards, string: deviceId
   private nextWebcam: Subject<boolean | string> = new Subject<boolean | string>();
  imageError: boolean;
  //isPicTaken: boolean;
  imagePath: string;
  returnUrl: string;
  //settime: NodeJS.Timer;
  userData: any;
  settings: any;
  usertoken: string;
  settime;   

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private photoauthservice: PhotoauthService,
    private authenticationService: AuthenticationService,
    private alertService: AlertService,
    private globals: Globals,
    private spinner: NgxSpinnerService,
    private http: HttpClient
  ) { }

  ngOnInit() {
    // var step = this.route.snapshot.paramMap.get("step");
    // this.studentid = parseInt(step);
    this.userinfo = JSON.parse(localStorage.getItem('userinfo_ps')); 
    this.usertoken = this.userinfo['usertoken'];
    this.studentid = this.userinfo['student_id'];
    this.imageError = false;
    this.isPicTaken = false;
    this.imagePath = this.userinfo['profile_pic']; //'/assets/images/picid-upload.png';   
     
    this.myProfile(); 

    WebcamUtil.getAvailableVideoInputs()
        .then((mediaDevices: MediaDeviceInfo[]) => {
            this.multipleWebcamsAvailable = mediaDevices && mediaDevices.length > 1;
        });
        //////////
  }

  public triggerSnapshot(): void {
    this.trigger.next();
    this.imagePath = this.webcamImage.imageAsDataUrl;
    this.isPicTaken = false;
    this.imageError = false;

}

public toggleWebcam(): void {
    this.showWebcam = !this.showWebcam;
}

public handleInitError(error: WebcamInitError): void {
    this.errors.push(error);
}

public showNextWebcam(directionOrDeviceId: boolean | string): void {
    // true => move forward through devices
    // false => move backwards through devices
    // string => move to device with given deviceId
    this.nextWebcam.next(directionOrDeviceId);
}

public handleImage(webcamImage: WebcamImage): void {
    this.webcamImage = webcamImage;
}

public cameraWasSwitched(deviceId: string): void {
    this.deviceId = deviceId;
}

public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
}

public get nextWebcamObservable(): Observable<boolean | string> {
    return this.nextWebcam.asObservable();
}

public webCameScreen(): void {
    this.isPicTaken = true;
    this.settime = setInterval(() => {
        this.iscameraLoaded = true;
        clearInterval(this.settime);
    }, 3000);
}


/*	public checkPhotoAuth(){
        this.spinner.show();
        this.photoauthService.checkPhotoAuth(this.globals.root_url, this.userData['usercode'], this.userData['userid'], this.userData['subuserid'], this.settings['exam_id'],'photo')
        .pipe(first())
        .subscribe(
            data => {
                if(data.code == 1000){
                    if(data.status == 'yes'){
                        var parms = this.globals.getRandUrl('test-start');
                        this.router.navigateByUrl('/test-start/'+parms);
                    }
                    else{
                        this.skippicSwal.show();
                    }
                }
                else if(data.status == 'COM_TOKEN_ERROR'){
                    this.loading = false;
                    this.router.navigateByUrl('/login');
                }
                else{
                    
                }
                this.spinner.hide();
            },
            error => {
                this.alertService.error(error);
                this.loading = false;
                this.spinner.hide();
            }
        );
    }*/


  myProfile() {
    this.authenticationService.studentprofile(this.globals.root_url, this.studentid, this.usertoken)
      .pipe(first())
      .subscribe(
        data => {
          this.spinner.hide();
          if (data.code == 1000) { 
            this.studentdetails = data.profile; 
            this.imageShow = this.studentdetails['profile_pic'];
            this.imagePath = this.studentdetails['profile_pic'];
            if(this.imagePath == '')
            {
              this.imagePath = '/assets/images/user.png';
            } 
            //console.log(this.imageShow)
          }
          else {
            this.isErrorUsername = true;
            this.errorMsg = data.status;
            this.loading = false;
          }
          this.spinner.hide();
        },
        error => {
          this.isErrorUsername = true;
          this.errorMsg = 'Invalid Usename !!';
          this.alertService.error(error);
          this.loading = false;
          this.spinner.hide();
        }
      );
  }

  fileProgress(e) {
    var file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
    var pattern = /image-*/;
    var reader = new FileReader();
    if (!file.type.match(pattern)) {
      alert('invalid format');
      return;
    }
    reader.onload = this._handleReaderLoaded.bind(this);
    reader.readAsDataURL(file);
  }

  _handleReaderLoaded(e) {
    let reader = e.target;
    this.imageSrc = reader.result;
    console.log(this.imageSrc)
    this.imageShow = this.imageSrc
  }


  /**
* upload-Profile-Image
*/

  uploadProfile() {
    // this.loading = true;
    this.profilepic = this.imageShow;
    this.spinner.show();
    this.photoauthservice.studentprofileImage(this.globals.root_url, this.studentid, this.profilepic)
      .pipe(first())
      .subscribe(
        data => {
          //console.log(data)
          //this.spinner.hide();
          if (data.code == 1000) {
            this.loading = false;
            this.imageShow = data.pic;

          }
          else {
            this.isErrorUsername = true;
            this.errorMsg = data.status;
            this.loading = false;
          }
          this.spinner.hide();
        },
        error => {
          this.isErrorUsername = true;
          this.errorMsg = 'Invalid File !!';
          this.alertService.error(error);
          this.loading = false;
          this.spinner.hide();
        }
      );
  }
  fileToLoad: File = null;
  attachfile: string
  public onSelectFile(selectedFile) {
          //console.log(selectedFile[0]);
    if(selectedFile[0] != 'undefined'){      
      if (selectedFile[0].type == 'image/png' || selectedFile[0].type == 'image/jpg' || selectedFile[0].type == 'image/jpeg') {
        var size = selectedFile[0].size;
        if(size >= 1048576)
        {
          this.attachInputVariable.nativeElement.value = "";
          this.imagesizeSwal.show();
          return;
        }
      } 
    }
    this.fileToLoad = selectedFile[0]; 
    var fileReader = new FileReader();
    fileReader.readAsDataURL(this.fileToLoad);
    fileReader.onload = (event: any) => {
      this.abc(event.target.result)

    };
    // console.log(this.attachfile)

  }
  filename = '';
  public abc(a) {
    this.attachfile = a;
    this.filename = this.fileToLoad.name;
    //console.log(this.attachfile);
    //console.log(this.fileToLoad.name);
  }  
 /**
* upload-Profile-WebImage
*/

  onFileSubmit() {
    this.loading = true;
    if (this.webcamImage && this.webcamImage.imageAsDataUrl) {
        this.spinner.show();
        // this.userData = JSON.parse(localStorage.getItem('userinfo_pc')); console.log(this.userData)
        // this.settings = JSON.parse(sessionStorage.pkshn_exam_set_pc);
        this.photoauthservice.studentWebImage(this.globals.root_url, this.studentid,this.webcamImage.imageAsDataUrl)
            .pipe(first())
            .subscribe(
                data => {
                  //console.log(data)
                    if (data.code == 1000) {
                        this.spinner.hide();
                        this.imageError = false;
                        this.showWebcam = false;
                        this.imageShow = data.pic;
                        this.imagePath = data.pic;
                        localStorage.setItem('userinfo_ps', JSON.stringify({ student_id: this.userinfo['student_id'], name: this.userinfo['name'], email: this.userinfo['email'], mobile: this.userinfo['mobile'], profile_pic: data.pic, usertoken: this.userinfo['usertoken'] }));                        
                        this.router.navigateByUrl('/dashboard');
                      
                    }
                    else if (data.status == 1001) {
                        this.spinner.hide();
                        this.loading = false;
                        this.router.navigateByUrl('/my-profile');
                    }
                    else {
                        this.spinner.hide();
                        this.imageError = true;
                        this.errorMsg = 'Image does not upload please retry !!';
                        this.loading = false;
                    }

                },
                error => {
                    this.imageError = true;
                    this.errorMsg = 'Image does not upload please retry !!';
                    this.alertService.error(error);
                    this.loading = false;
                    this.spinner.hide();
                }
            );
    }
    else if(this.attachfile)
    {
            this.spinner.show();
            this.photoauthservice.studentWebImage(this.globals.root_url, this.studentid,this.attachfile)
            .pipe(first())
            .subscribe(
                data => {
                  //console.log(data)
                    if (data.code == 1000) {
                        this.spinner.hide();
                        this.imageError = false;
                        this.imagePath = data.pic;
                        localStorage.setItem('userinfo_ps', JSON.stringify({ student_id: this.userinfo['student_id'], name: this.userinfo['name'], email: this.userinfo['email'], mobile: this.userinfo['mobile'], profile_pic: data.pic, usertoken: this.userinfo['usertoken'] }));                           
                        this.router.navigateByUrl('/dashboard');
                      
                    }
                    else if (data.status == 1001) {
                        this.spinner.hide();
                        this.loading = false;
                        this.router.navigateByUrl('/my-profile');
                    }
                    else {
                        this.spinner.hide();
                        this.imageError = true;
                        this.errorMsg = 'Image does not upload please retry !!';
                        this.loading = false;
                    }

                },
                error => {
                    this.imageError = true;
                    this.errorMsg = 'Image does not upload please retry !!';
                    this.alertService.error(error);
                    this.loading = false;
                    this.spinner.hide();
                }
            );      
    }
    else {
        this.imageError = true;
        this.errorMsg = 'Invalid Image !!';
        this.loading = false;
    }
}
 goDashboard()
 {
  this.router.navigateByUrl('/dashboard'); 
 } 
}
